/**
 * Assemblage de tout le contenu du Centre d'aide, dans l'ordre d'affichage.
 *
 * Chaque section est filtrée par rôle au moment du rendu (cf. `useDocs`). Pour
 * ajouter une rubrique : créer un fichier dans `sections/`, l'importer ici, et
 * lui donner un `minRole` adapté.
 */
import type { DocSection } from './types'

import { startSection } from './sections/start'
import { callsSection } from './sections/calls'
import { planningSection } from './sections/planning'
import { statusesSection } from './sections/statuses'
import { dispositionsSection } from './sections/dispositions'
import { callbacksSection } from './sections/callbacks'
import { trackingSection } from './sections/tracking'
import { historySection } from './sections/history'
import { toolsSection } from './sections/tools'
import { campaignsSection } from './sections/campaigns'
import { dialerSection } from './sections/dialer'
import { blacklistSection } from './sections/blacklist'
import { contactsSection } from './sections/contacts'
import { telephonySection } from './sections/telephony'
import { supervisionSection } from './sections/supervision'
import { usersSection } from './sections/users'
import { troubleshootingSection } from './sections/troubleshooting'

export const docSections: DocSection[] = [
  startSection,
  callsSection,
  planningSection,
  statusesSection,
  dispositionsSection,
  callbacksSection,
  trackingSection,
  historySection,
  toolsSection,
  campaignsSection,
  dialerSection,
  blacklistSection,
  contactsSection,
  telephonySection,
  supervisionSection,
  usersSection,
  troubleshootingSection,
]
